import { addMinutes, differenceInMinutes } from 'date-fns';
import { SLOT_MINUTES, SLOT_HEIGHT_PX } from '../utils/timeGrid';

export function snapMinutesToSlot(minutes, slotMinutes = SLOT_MINUTES) {
  return Math.round(minutes / slotMinutes) * slotMinutes;
}

export function snapDateTimeToSlot(date, slotMinutes = SLOT_MINUTES) {
  if (!date || Number.isNaN(date.getTime())) return null;
  const snapped = new Date(date);
  const dayMinutes = snapped.getHours() * 60 + snapped.getMinutes();
  const snappedDayMinutes = snapMinutesToSlot(dayMinutes, slotMinutes);
  snapped.setHours(Math.floor(snappedDayMinutes / 60), snappedDayMinutes % 60, 0, 0);
  return snapped;
}

/**
 * Convert a pointer Y position within a grid body to a snapped start time.
 * @param {number} clientY
 * @param {HTMLElement} gridBodyEl
 * @param {Date} gridStart
 * @param {Date} gridEnd
 */
export function pointerYToGridTime(clientY, gridBodyEl, gridStart, gridEnd) {
  const rect = gridBodyEl.getBoundingClientRect();
  const y = clientY - rect.top;
  const totalMinutes = Math.max(differenceInMinutes(gridEnd, gridStart), SLOT_MINUTES);
  const totalHeight = (totalMinutes / SLOT_MINUTES) * SLOT_HEIGHT_PX;
  const clampedY = Math.max(0, Math.min(y, totalHeight - 1));
  const minutesFromStart = (clampedY / SLOT_HEIGHT_PX) * SLOT_MINUTES;
  const snappedMinutes = snapMinutesToSlot(minutesFromStart);
  const maxMinutes = Math.max(totalMinutes - SLOT_MINUTES, 0);
  const boundedMinutes = Math.max(0, Math.min(snappedMinutes, maxMinutes));
  return addMinutes(gridStart, boundedMinutes);
}

export function isTimeRangeWithinGrid(start, durationMinutes, gridStart, gridEnd) {
  if (!start || !gridStart || !gridEnd) return false;
  const end = addMinutes(start, durationMinutes);
  return start.getTime() >= gridStart.getTime() && end.getTime() <= gridEnd.getTime();
}

export function layoutPreviewPixels(start, durationMinutes, gridStart, gridEnd) {
  const end = addMinutes(start, durationMinutes);
  const g0 = gridStart.getTime();
  const g1 = gridEnd.getTime();
  let s = start.getTime();
  let e = end.getTime();
  if (e <= g0 || s >= g1) return null;
  s = Math.max(s, g0);
  e = Math.min(e, g1);
  const minutesFromStart = differenceInMinutes(new Date(s), gridStart);
  const duration = Math.max(differenceInMinutes(new Date(e), new Date(s)), 15);
  const topPx = (minutesFromStart / SLOT_MINUTES) * SLOT_HEIGHT_PX;
  const heightPx = Math.max((duration / SLOT_MINUTES) * SLOT_HEIGHT_PX, SLOT_HEIGHT_PX * 0.9);
  return { topPx, heightPx };
}
